/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The QR code is generated entirely in your browser, so the content you type never leaves your device.`)
};

const es_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El código QR se genera por completo en tu navegador, así que el contenido que escribes nunca sale de tu dispositivo.`)
};

const de_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der QR-Code wird vollständig in deinem Browser erzeugt, sodass der eingegebene Inhalt dein Gerät nie verlässt.`)
};

const nl_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De QR-code wordt volledig in je browser gegenereerd, dus de inhoud die je typt verlaat je apparaat nooit.`)
};

const fr_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le QR code est généré entièrement dans votre navigateur, donc le contenu que vous tapez ne quitte jamais votre appareil.`)
};

const it_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Il codice QR viene generato interamente nel tuo browser, quindi il contenuto che digiti non lascia mai il tuo dispositivo.`)
};

const pt_br2_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O código QR é gerado inteiramente no seu navegador, então o conteúdo que você digita nunca sai do seu dispositivo.`)
};

const pt_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O código QR é gerado inteiramente no seu navegador, pelo que o conteúdo que escreve nunca sai do seu dispositivo.`)
};

const ja_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。QRコードはブラウザ内で完全に生成されるため、入力した内容が端末の外に出ることはありません。`)
};

const zh_qr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。二维码完全在你的浏览器中生成，你输入的内容不会离开设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const qr_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.qr_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("qr_faq_a3", locale)
	if (locale === "en") return en_qr_faq_a3(inputs)
	if (locale === "es") return es_qr_faq_a3(inputs)
	if (locale === "de") return de_qr_faq_a3(inputs)
	if (locale === "nl") return nl_qr_faq_a3(inputs)
	if (locale === "fr") return fr_qr_faq_a3(inputs)
	if (locale === "it") return it_qr_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_qr_faq_a3(inputs)
	if (locale === "pt") return pt_qr_faq_a3(inputs)
	if (locale === "ja") return ja_qr_faq_a3(inputs)
	return zh_qr_faq_a3(inputs)
};